import { utcToZonedTime, format } from 'date-fns-tz';
import { parseISO } from 'date-fns';

export const formatDateTimeZone = dateStr => {
  const nyTimeZone = 'America/New_York';
  const nyDate = utcToZonedTime(parseISO(dateStr), nyTimeZone);
  return format(nyDate, 'h:mm aaaa (zzz)', {
    timeZone: 'America/New_York',
  });
};
